import React from "react";
export type GlobalScreenContextState = {
  currentScreen: string;
  setCurrentScreen: (nameScreen: string) => void;
};

const GlobalScreenContextDefaultValues: GlobalScreenContextState = {
  currentScreen: "",
  setCurrentScreen: () => {},
};

export const GlobalScreenContext = React.createContext<GlobalScreenContextState>(GlobalScreenContextDefaultValues);
